import { render, staticRenderFns } from "./hover-menu.vue?vue&type=template&id=171e46f7"
import script from "./hover-menu.vue?vue&type=script&lang=js"
export * from "./hover-menu.vue?vue&type=script&lang=js"
import style0 from "./hover-menu.vue?vue&type=style&index=0&id=171e46f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports